import React, { useEffect, useState } from "react";
import Page from "../../common/layout/Page";
import Loader from "../../common/Loader";
import dataService from "../../../helpers/dataService";
import StatutImportBadge from "./components/StatutImportBadge";
import CompteursImport from "./components/CompteursImport";
import LignesEnErreurTable from "./components/LignesEnErreurTable";
import { formatDuree } from "./components/importFormatters";

// Tant que l'import est EN_COURS, on rafraîchit le détail à ce rythme pour
// suivre la progression (`lignesTraitees`).
const INTERVALLE_RAFRAICHISSEMENT_MS = 5000;

function formatDeclencheur(declencheur) {
  if (declencheur === "CRON") {
    return "Tâche planifiée (CRON)";
  }
  if (declencheur === "MANUEL") {
    return "Déclenché manuellement";
  }
  return declencheur || "-";
}

const ImportDetail = (props) => {
  const importId = props.match.params.id;
  const [importData, setImportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState(false);

  const statut = importData ? importData.statut : null;

  useEffect(() => {
    setImportData(null);
    chargerImport(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [importId]);

  // Progression en direct pendant le traitement, coupée dès que l'import
  // quitte EN_COURS et au démontage du composant.
  useEffect(() => {
    if (statut !== "EN_COURS") {
      return undefined;
    }
    const intervalId = setInterval(() => {
      chargerImport(false);
    }, INTERVALLE_RAFRAICHISSEMENT_MS);
    return () => clearInterval(intervalId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statut, importId]);

  function chargerImport(afficherLoader) {
    if (afficherLoader) {
      setIsLoading(true);
    }
    setErrors(false);
    dataService.get(
      `imports/${importId}`,
      (data) => setImportData(data),
      setErrors,
      () => {
        if (afficherLoader) {
          setIsLoading(false);
        }
      }
    );
  }

  return (
    <Page
      container="container-fluid px-5"
      title="Détail de l'import"
      subTitle={importData ? importData.nomFichier || "" : ""}
      back="/imports"
      errors={errors}
    >
      {isLoading ? (
        <Loader />
      ) : !importData ? null : (
        <>
          <div className="d-flex align-items-center flex-wrap mb-4">
            <StatutImportBadge
              statut={importData.statut}
              statutLabel={importData.statutLabel}
            />
            <span className="ml-3">{importData.typeLabel}</span>
          </div>

          <div className="row mb-3">
            <div className="col-12 col-md-4 mb-3">
              <strong>Fichier</strong>
              <div>{importData.nomFichier || "-"}</div>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <strong>Déclenché par</strong>
              <div>{formatDeclencheur(importData.declencheur)}</div>
            </div>
            <div className="col-12 col-md-4 mb-3">
              <strong>Durée</strong>
              <div>{formatDuree(importData.dureeMs)}</div>
            </div>
          </div>

          {importData.statut === "ECHEC" && importData.erreur && (
            <div className="alert alert-danger">{importData.erreur}</div>
          )}

          {importData.statut === "EN_COURS" && (
            <div className="alert alert-info">
              Import en cours… {importData.lignesTraitees} ligne
              {importData.lignesTraitees > 1 ? "s" : ""} traitée
              {importData.lignesTraitees > 1 ? "s" : ""} pour le moment
              (rafraîchissement automatique toutes les 5 secondes).
            </div>
          )}

          <CompteursImport
            compteurs={importData.compteurs}
            type={importData.type}
            variant="detail"
          />

          {importData.compteurs.enErreur > 0 && (
            <LignesEnErreurTable
              importId={importData.id}
              onApresRejeu={() => chargerImport(false)}
            />
          )}
        </>
      )}
    </Page>
  );
};

export default ImportDetail;
